<script setup lang="ts">
  import { onMounted } from 'vue';
  import { client } from '@/utils';
  import { useRoute, useRouter, type RouteLocationRaw } from 'vue-router';

  const route = useRoute();

  onMounted(async () => {
    await client.getOrCreateAuthClient();
    const redirectUrl = route.query.redirectUrl as string;
    client.logout(redirectUrl);
  });
</script>

<template>
  <div class="flex items-center justify-center h-screen p-4 text-2xl font-bold">
    <div v-if="redirectUrl">{{ $t('redirecting') }}</div>
    <div v-else>{{ $t('logged out') }}</div>
  </div>
</template>
